<template>
  <div class="card">
    <DataView :value="projects" :layout="layout">
      <template #header>
        <div class="flex justify-content-start">
          <Button
            icon="pi pi-plus"
            class="p-button-secondary"
            label="Novo Projeto"
            @click="showCreate()"
          />
        </div>
        <div class="flex justify-content-start">
          <DataViewLayoutOptions v-model="layout" class="mt-1" />
        </div>
      </template>

      <template #grid="slotProps">
        <div class="grid grid-nogutter">
          <div class="col-12 sm:col-6 md:col-4 xl:col-6 p-2">
            <Card style="width: 15em">
              <template #content>
                <div class="container">
                  <img
                    src="../../../public/images/sespa/folder.png"
                    alt="IMAGEM"
                  />
                  <div class="texto text-center mt-5">
                    {{ slotProps.data.name.toUpperCase() }}
                  </div>
                </div>
                <div class="flex justify-content-center border-round p-3">
                  <Button
                    icon="pi pi-eye"
                    class="p-button-secondary p-button-lg mr-2"
                    @click="showfolder(slotProps.data)"
                  />
                  <Button
                    icon="pi pi-pencil"
                    class="p-button-success p-button-lg mr-2"
                    @click="showUpdate(slotProps.data)"
                  />
                  <Button
                    icon="pi pi-trash"
                    class="p-button-danger p-button-lg"
                    @click="showRemove(slotProps.data)"
                  />
                </div>
              </template>
            </Card>
          </div>
        </div>
      </template>

      <template #list="slotProps">
        <Toolbar class="col-12 mt-2" style="background-color: #fff">
          <template #start>
            <div class="container ml-2 mt-2">
              <img alt="IMAGEM" src="../../../public/images/sespa/folder.png" />
              <div class="texto">{{ slotProps.data.name.toUpperCase() }}</div>
            </div>
          </template>

          <template #end>
            <div class="mr-4">
              <Button
                icon="pi pi-eye"
                class="p-button-secondary p-button-lg mr-2"
                @click="showfolder(slotProps.data)"
              />
              <Button
                icon="pi pi-pencil"
                class="p-button-success p-button-lg mr-2"
                @click="showUpdate(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-danger p-button-lg"
                @click="showRemove(slotProps.data)"
              />
            </div>
          </template>
        </Toolbar>
      </template>
    </DataView>
  </div>
  <!--MODAL CADASTRAR-->
  <dialog-form :selectedProject="project" @findAll="findAll" />
  <!--FIM MODAL CADASTRAR-->

  <!--MODAL LIST-->
  <dialog-view :selectedProject="project" @findAll="findAll" />
  <!--FIM MODAL LIST-->
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
//models
import Project from "../../models/project";
import Folder from "../../models/folder";

//Services
import ProjectService from "../../service/project/project_service";
import FolderService from "../../service/folder/folder_service";

//components
import DialogForm from "./components/dialog-form.vue";
import DialogView from "../folders/dialog-view.vue";

export default {
  components: {
    DialogForm,
    DialogView,
  },
  data() {
    return {
      loading: false,
      projects: [],
      project: new Project(),
      projectService: new ProjectService(),

      folders: [],
      folder: new Folder(),
      folderService: new FolderService(),

      layout: "grid",
      filters: {},
    };
  },
  mounted() {
    this.findAll();
  },
  methods: {
    showCreate() {
      this.project = new Project();
      this.$store.state.views.project.dialogForm = true;
    },
    showUpdate(project) {
      this.project = { ...project };
      this.$store.state.views.project.dialogForm = true;
    },
    showRemove(project) {
      this.project = project;
      this.$confirm.require({
        message: "Deseja excluir esse projeto?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.projectService
            .delete(this.project.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((err) => {
              this.$msgErro(err);
            });
        },
      });
    },
    showfolder(project) {
      this.project = { ...project };
      this.$store.state.views.folder.dialogList = true;
    },
    findAll() {
      this.loading = true;
      this.projectService.findAll().then((data) => {
        this.projects = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");

.container {
  display: flex;
  align-items: center; /* Alinha verticalmente ao centro */
  margin: 20px 0;
  flex-wrap: wrap; /* Permite que os itens se movam para a linha seguinte em telas menores */
}
.container img {
  max-width: 100%; /* A imagem ocupa 100% da largura disponível */
  height: auto; /* Mantém a proporção da imagem */
  max-width: 150px; /* Limita a largura máxima da imagem */
  margin-right: 20px; /* Espaço entre a imagem e o texto */
  margin-left: 10px;
}
.container .texto {
  font-size: 1.2em; /* Tamanho da fonte */
  font-weight: bold; /* Texto em negrito */
  color: #333; /* Cor do texto */
  flex: 1; /* Faz o texto ocupar o restante do espaço disponível */
}
@media (max-width: 600px) {
  .container {
    flex-direction: column; /* Muda para coluna em telas menores */
    align-items: flex-start; /* Alinha os itens à esquerda */
  }
  .container img {
    margin-right: 0; /* Remove a margem direita na visualização em coluna */
    margin-bottom: 10px; /* Adiciona espaço abaixo da imagem */
  }
}
</style>
